var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('image-cell',{attrs:{"content":_vm.url,"attribute":_vm.attribute}})}
var staticRenderFns = []

export { render, staticRenderFns }